import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {

  publishNewSession: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presenting-sessions/snapshots?masterPresentationId={presentationId}`,
  },
  getPresentationMasterByPublishId: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presenting-sessions/master-presentations/by-snapshot-id/{presentationId}?alwaysGetRootPresentation={getRootPresentation}`,
  },
  getListSessionsByPresentationId: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presenting-sessions/snapshots?masterPresentationId={presentationId}&limit=100`,
  },
  getPresentationDetailBySession: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presenting-sessions/snapshots/{presentationId}`,
  },

  createInstructor: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presenting-sessions/master-presentations/{presentationId}/instructors`,
  },

  getListInstructorByPresentationId: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presenting-sessions/master-presentations/{presentationId}/instructors`,
  },

  deleteInstructor: {
    method: 'DELETE',
    url: `${configs.baseUrl}/api/presenting-sessions/master-presentations/{presentationId}/instructors`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getPresentationMasterByPresentationId = (presentationId, getRootPresentation = false) => {
  return resource.getPresentationMasterByPublishId({ getRootPresentation, presentationId })
}

const publishNewSession = (presentationId) => {
  return resource.publishNewSession({ presentationId }, null)
}

const getListSessionsByPresentationId = (presentationId) => {
  return resource.getListSessionsByPresentationId({ presentationId })
}

const getPresentationDetailBySession = (presentationId) => {
  return resource.getPresentationDetailBySession({ presentationId })
}

const createInstructor = async (presentationId, payload) => {
  return resource.createInstructor({ presentationId }, payload)
}

const deleteInstructor = async (presentationId, payload) => {
  return resource.deleteInstructor({ presentationId }, payload)
}

const getListInstructorByPresentationId = async (presentationId) => {
  return resource.getListInstructorByPresentationId({ presentationId })
}

export default {
  initResource,
  publishNewSession,
  getPresentationMasterByPresentationId,
  getListSessionsByPresentationId,
  getPresentationDetailBySession,
  createInstructor,
  getListInstructorByPresentationId,
  deleteInstructor,
}
